import * as React from "react"

const SvgArrowUp = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M13.006 8.107v11.178a.97.97 0 0 1-.287.713.97.97 0 0 1-.713.288.97.97 0 0 1-.712-.288.97.97 0 0 1-.287-.713V8.107l-4.9 4.901q-.3.3-.7.288a1 1 0 0 1-.7-.313 1.06 1.06 0 0 1-.287-.7.92.92 0 0 1 .288-.7l6.599-6.602a.9.9 0 0 1 .325-.213q.174-.062.374-.062.201 0 .375.062a.9.9 0 0 1 .325.213l6.599 6.602a.93.93 0 0 1 .275.688q0 .412-.275.712-.3.3-.712.3a.97.97 0 0 1-.713-.3z" />
  </svg>
)
export default SvgArrowUp
